export default "/images/6e90e8f0985b4f32faf5d31b72d8e56c.avif";